import { Button, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { MISC_PRIMARY, MISC_PRIMARY_HOVER } from '../../theme/onboardingTheme'

export function LoginStatesIntro() {
  const { goToStep } = useOnboarding()

  return (
    <Typography component="p" sx={{ fontSize: 16, lineHeight: 1.625, color: '#1e293b' }}>
      If you need to update the selected states for filings MISC should handle,{' '}
      <Button
        type="button"
        onClick={() => goToStep('generalQuestions')}
        sx={{
          minWidth: 0,
          p: 0,
          verticalAlign: 'baseline',
          fontSize: 'inherit',
          fontWeight: 600,
          lineHeight: 'inherit',
          color: MISC_PRIMARY,
          textDecoration: 'underline',
          textTransform: 'none',
          '&:hover': { color: MISC_PRIMARY_HOVER, backgroundColor: 'transparent', textDecoration: 'underline' },
        }}
      >
        please click here
      </Button>
      .
    </Typography>
  )
}
